import { type InputHTMLAttributes, type ReactNode, forwardRef } from 'react';

import { classNames } from './classNames';

export type SwitchProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'role' | 'type'> & {
  label: ReactNode;
};

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, label, ...props }, ref) => (
    <label className={classNames('hotam-switch', className)}>
      <input
        ref={ref}
        className='hotam-switch__input'
        role='switch'
        type='checkbox'
        {...props}
      />
      <span
        aria-hidden='true'
        className='hotam-switch__track'
      >
        <span className='hotam-switch__thumb' />
      </span>
      <span className='hotam-switch__label'>{label}</span>
    </label>
  ),
);

Switch.displayName = 'Switch';
